import {
	SHOW_ADD_CARD,
	HIDE_ADD_CARD,
	SHOW_EDIT_CARD,
	HIDE_EDIT_CARD,
	SHOW_DELETE_CARD,
	HIDE_DELETE_CARD,
	UPDATE_CARD,
	UPDATE_CARDS,
	CLEAR_CARD,
	// CLEAR_CARDS, //TODO: Most likely remove this.
	UPDATE_INVOICE,
	UPDATE_INVOICES,
	ADD_CHARGE,
	UPDATE_CHARGE,
	UPDATE_CHARGES,
	UPDATE_CUSTOMER,
	UPDATE_CUSTOMER_CARD,
	ADD_CUSTOMER_CARD,
	CLEAR_CUSTOMER
} from 'constants';

//Storage for components handling account information. (Billing, credit cards, invoices, charges, etc)
export const account = (state = {
	customer : null,
	addingCard : false,
	editingCard : false,
	deletingCard : false,
	card : null, //Temp storage for currently viewed card.
	charge : null, //Temp storage for currently viewed charge.
	invoice : null, //Temp storage for currently viewed invoice.
	charges : null, //Storage for charges object.
	invoices : [] //Storage for list of invoices.
}, action) => {
	switch(action.type) {
		case SHOW_ADD_CARD:
			return Object.assign({}, state, {addingCard : true , card : null });
		case HIDE_ADD_CARD:
			return Object.assign({}, state, {addingCard : false , card : null });
		case SHOW_EDIT_CARD:
			return Object.assign({}, state, {editingCard : true , card : null });
		case HIDE_EDIT_CARD:
			return Object.assign({}, state, {editingCard : false , card : null });
		case SHOW_DELETE_CARD:
			return Object.assign({}, state, {deletingCard : true, card : null });
		case HIDE_DELETE_CARD:
			return Object.assign({}, state, {deletingCard : false, card : null });
		case UPDATE_CARD:
			return Object.assign({}, state, {card : action.card});
		case UPDATE_CARDS:
			return Object.assign({}, state, {cards : action.cards});
		case CLEAR_CARD:
			return Object.assign({}, state, {card : null});
		case UPDATE_CUSTOMER_CARD:
			if(state.customer) {
				for (var i = 0; i < state.customer.sources.data.length; i++) {
					var data = state.customer.sources.data;
					if(data[i].id == action.card.id) {
						var newData = data.slice(); //Copy sources array.
						newData[i] = action.card; //Assign the card to the array.
						var newState = Object.assign({},state);
						state.customer.sources.data = newData;
						return state;
					}
				};
			}
			else {
				return state;
			}
		case ADD_CUSTOMER_CARD:
			if(state.customer) {
				var stateCopy = Object.assign({},state);
				stateCopy.customer.sources.data.push(action.card);
				return stateCopy;
			}
			else {
				return state;
			}

		case UPDATE_CUSTOMER:
			return Object.assign({}, state, {customer: action.customer });
		case CLEAR_CUSTOMER:
			return Object.assign({}, state, {customer : null });

		case ADD_CHARGE:
			var newState = Object.assign({},state);
			newState.charges.data = [action.charge].concat(newState.charges.data.slice(0))
			return newState;
		case UPDATE_CHARGES:
			return Object.assign({}, state, {
				charges : action.charges
			});
		case UPDATE_CHARGE: 
			var newState = Object.assign({},state);

			for (var i = 0; i < state.charges.length; i++) {
				if(newState.charges.data[i].id == action.charge.id) {
					newState.charges.data[i] = action.charge;
					return newState;
				}
			};
			return state;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/common/reducers/account.js